import 'react-loading-skeleton/dist/skeleton.css';

import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

interface Alter25SkeletonProps {
  className?: string;
  colorSet?: 'grey' | 'red';
  borderRadius?: string | number;
}

export const Alter25Skeleton: React.FC<Alter25SkeletonProps> = ({
  className,
  colorSet,
  borderRadius,
}: Alter25SkeletonProps) => {
  let baseColor = '#ebebeb';
  let highlightColor = '#dddddd';

  switch (colorSet) {
    case 'grey':
      baseColor = '#ebebeb';
      highlightColor = '#dddddd';
      break;
    case 'red':
      baseColor = '#e0432e';
      highlightColor = 'white';
      break;
  }

  return (
    <div className={className}>
      <SkeletonTheme
        baseColor={baseColor}
        highlightColor={highlightColor}
        borderRadius={borderRadius}
      >
        <Skeleton />
      </SkeletonTheme>
    </div>
  );
};
